import apiService from '../../apiService/apiService'
import * as types from './constants'
import rooms from '../../pages/Tools/rooms'
import { nanoid } from 'nanoid'
import mokaber from '../../assets/img/2000-01 (2).jpg'
import FastAverageColor from 'fast-average-color'
import { drawPerspective } from '../../helper/drawWarpHelper'
import { getImageAbsolutePath } from '../../helper/imageHelper'
import { warpOnCube } from '../../helper/drawHelper'
import roomItem from '../../pages/Tools/rooms/roomItem/roomItem'

var globalMultiply = 0.8

const paper = window.paper
const d3 = window.d3
const fac = new FastAverageColor()

const corsChangeURL = 'http://185.164.73.236:8080/'
//const corsChangeURL='http://localhost:8080/'

export const setPhotoEditorMaterial = (material) => {
    return (dispatch) => {
        dispatch({
            type: types.SET_PHOTO_EDITOR_MATERIAL,
            payload: material,
        })
    }
}

export const closePhotoEditorMaterial = () => {
    return (dispatch) => {
        dispatch({
            type: types.CLOSE_PHOTO_EDITOR_MATERIAL,
        })
    }
}

export const getMaterials = (pageNumber, searchText) => {
    return (dispatch, getState) => {
        const allMaterials =
            pageNumber === 1 ? [] : getState().tools.allMaterials ?? []
        apiService.materials
            .getAll(pageNumber, searchText)
            .then((response) => {
                if (response.status == 200) {
                    dispatch({
                        type: types.GET_MATERIALS_SUCCESS,
                        payload: [
                            ...allMaterials,
                            ...response.data.map((q) => ({
                                ...q,
                                title: q.name,
                                url:
                                    corsChangeURL +
                                    (q.meta_data.filter((x) => x.key == 'pic_pattern' && x.value!="0").length > 0
                                        ? `https://mokabber.com/?attachment_id=${
                                              q.meta_data.find(
                                                  (x) => x.key == 'pic_pattern'
                                              ).value
                                          }`
                                        : q.images[0].src.replace(
                                              '.jpg',
                                              '-300x300.jpg'
                                          )),
                                // url:
                                //     q.appThumbnail ??
                                //     getImageAbsolutePath(q.originalImageUrl),
                                originalThumbnailUrl:
                                    corsChangeURL +
                                    (q.meta_data.filter((x) => x.key == 'pic_pattern' && x.value!="0").length > 0
                                    ? `https://mokabber.com/?attachment_id=${
                                          q.meta_data.find(
                                              (x) => x.key == 'pic_pattern'
                                          ).value
                                      }`
                                    : q.images[0].src.replace(
                                          '.jpg',
                                          '-300x300.jpg'
                                      )),
                                // originalThumbnailUrl:
                                //     q.appThumbnail ??
                                //     getImageAbsolutePath(
                                //         q.originalThumbnailUrl
                                //     ),
                                id: q.id,
                                //id: q.fabricId ?? q.id,
                                editedImageUrl:
                                    corsChangeURL +
                                    (q.meta_data.filter((x) => x.key == 'pic_pattern' && x.value!="0").length > 0
                                        ? `https://mokabber.com/?attachment_id=${
                                              q.meta_data.find(
                                                  (x) => x.key == 'pic_pattern'
                                              ).value
                                          }`
                                        : q.images[0].src.replace(
                                              '.jpg',
                                              '-300x300.jpg'
                                          )),
                                // editedImageUrl: q.editedImageUrl
                                //     ? getImageAbsolutePath(
                                //           `${q.editedImageUrl}?v=${Date.now()}`
                                //       )
                                //     : null,
                                editedThumbnailUrl:
                                    corsChangeURL +
                                    (q.meta_data.filter((x) => x.key == 'pic_pattern' && x.value!="0").length > 0
                                        ? `https://mokabber.com/?attachment_id=${
                                              q.meta_data.find(
                                                  (x) => x.key == 'pic_pattern'
                                              ).value
                                          }`
                                        : q.images[0].src.replace(
                                              '.jpg',
                                              '-300x300.jpg'
                                          )),
                                // editedThumbnailUrl: q.editedThumbnailUrl
                                //     ? getImageAbsolutePath(
                                //           `${
                                //               q.editedThumbnailUrl
                                //           }?v=${Date.now()}`
                                //       )
                                //     : null,
                                originalImageUrl: null,
                                fabricId: null,
                            })),
                        ],
                    })
                } else {
                    dispatch({
                        type: types.OPERATION_FAILED,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.OPERATION_FAILED,
                    error: errorMessage,
                })
            })
    }
}

export const uploadMaterial = (name, file) => {
    const data = {
        title: name,
        file,
    }
    return (dispatch) => {
        dispatch({
            type: types.OPERATION_STARTED,
        })

        apiService.materials
            .create(data)
            .then((response) => {
                if (response.status == 200) {
                    dispatch({
                        type: types.UPLOAD_MATERIAL_SUCCESS,
                    })
                    dispatch(getMaterials())
                } else {
                    dispatch({
                        type: types.OPERATION_FAILED,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.OPERATION_FAILED,
                    error: errorMessage,
                })
            })
    }
}

export const editMaterial = (file, { patternFlipH, patternFlipV }) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.OPERATION_STARTED,
        })

        const { id } = getState().tools.photoEditorMaterial
        apiService.materials
            .updateImage({ id, file, patternFlipH, patternFlipV })
            .then((response) => {
                if (response.status == 200) {
                    dispatch({
                        type: types.UPLOAD_MATERIAL_SUCCESS,
                    })
                    dispatch(getMaterials())
                } else {
                    dispatch({
                        type: types.OPERATION_FAILED,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.OPERATION_FAILED,
                    error: errorMessage,
                })
            })
    }
}

export const resetMaterial = (id) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.OPERATION_STARTED,
        })

        apiService.materials
            .resetEditedImage(id)
            .then((response) => {
                if (response.status == 200 || response.status == 204) {
                    dispatch({
                        type: types.RESET_MATERIAL_SUCCESS,
                    })
                    dispatch(getMaterials())
                } else {
                    dispatch({
                        type: types.OPERATION_FAILED,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.OPERATION_FAILED,
                    error: errorMessage,
                })
            })
    }
}

export const deleteMaterial = (materialId) => {
    const data = { id: materialId }
    return (dispatch, getState) => {
        dispatch({
            type: types.OPERATION_STARTED,
        })

        apiService.materials
            .delete(data)
            .then((response) => {
                if (response.status == 200 || response.status == 204) {
                    dispatch({
                        type: types.DELETE_MATERIAL_SUCCESS,
                    })
                    dispatch(getMaterials())
                } else {
                    dispatch({
                        type: types.OPERATION_FAILED,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.OPERATION_FAILED,
                    error: errorMessage,
                })
            })
    }
}

export const updateMaterialTitle = (id, title) => {
    const data = {
        title,
    }
    return (dispatch) => {
        dispatch({
            type: types.OPERATION_STARTED,
        })
        apiService.materials
            .update(id, data)
            .then((response) => {
                if (response.status == 200 || response.status == 204) {
                    dispatch({
                        type: types.EDIT_MATERIAL_TITLE_SUCCESS,
                    })
                    dispatch(getMaterials())
                } else {
                    dispatch({
                        type: types.OPERATION_FAILED,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.OPERATION_FAILED,
                    error: errorMessage,
                })
            })
    }
}

export const activePath = (id) => {
    return {
        type: types.ACTIVE_PATH,
        payload: id,
    }
}

export const getRoom = (id) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.OPERATION_STARTED,
        })
        apiService.rooms
            .getOne(id)
            .then((response) => {
                if (response.status == 200) {
                    const room = response.data
                    const convertedRoom = {
                        ...room,
                        image: getImageAbsolutePath(room.originalImageUrl),
                        id: room.projectId,
                        layers: room.projectData
                            ? JSON.parse(room.projectData).layers
                            : [{ children: [] }],
                        projectData: null,
                        originalImageUrl: null,
                        editedImageUrl: room.editedImageUrl
                            ? getImageAbsolutePath(
                                  `${room.editedImageUrl}?v=${Date.now()}`
                              )
                            : null,
                    }
                    dispatch({
                        type: types.GET_ROOM_SUCCESS,
                        payload: convertedRoom,
                    })
                } else {
                    dispatch({
                        type: types.OPERATION_FAILED,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.OPERATION_FAILED,
                    error: errorMessage,
                })
            })
    }
}

export const getRooms = () => {
    return (dispatch, getState) => {
        dispatch({
            type: types.OPERATION_STARTED,
            payload: rooms,
        })
        apiService.rooms
            .getAll()
            .then((response) => {
                if (response.status == 200) {
                    const rooms = response.data
                    const convertedRooms = rooms.map((q) => ({
                        ...q,
                        image: getImageAbsolutePath(q.originalImageUrl),
                        originalThumbnailUrl: getImageAbsolutePath(
                            q.originalThumbnailUrl
                        ),
                        id: q.projectId,
                        layers: q.projectData
                            ? JSON.parse(q.projectData).layers
                            : [{ children: [] }],
                        projectData: null,
                        originalImageUrl: null,
                        editedThumbnailUrl: q.editedThumbnailUrl
                            ? getImageAbsolutePath(
                                  `${q.editedThumbnailUrl}?v=${Date.now()}`
                              )
                            : null,
                        editedImageUrl: q.editedImageUrl
                            ? getImageAbsolutePath(
                                  `${q.editedImageUrl}?v=${Date.now()}`
                              )
                            : null,
                    }))
                    const data = JSON.parse(localStorage.getItem('rooms'))
                    data.rooms = convertedRooms
                    localStorage.setItem('rooms', JSON.stringify(data))
                    dispatch({
                        type: types.GET_ROOMS_SUCCESS,
                        payload: convertedRooms,
                    })
                } else {
                    dispatch({
                        type: types.OPERATION_FAILED,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.OPERATION_FAILED,
                    error: errorMessage,
                })
            })
    }
}

var oldWidth = null
var oldHeight = null
export const chooseRoom = (room) => {
    return (dispatch) => {
        dispatch({
            type: types.CHOOSE_ROOM_INITIAL,
        })
        var canvas = document.getElementById('selection')
        var img = document.createElement('img')
        img.crossOrigin = 'Anonymous'
        img.onload = () => {
            oldWidth = img.width
            oldHeight = img.height
            var newHeight = img.height
            var newWidth = img.width

            // var newHeight = img.height
            if (img.width > 1000) {
                newWidth = 1000
                newHeight = (img.height / img.width) * 1000
            }

            img.width = newWidth
            img.height = newHeight

            canvas.setAttribute('width', newWidth)
            canvas.setAttribute('height', newHeight)
            paper.setup(canvas)
            paper.project.clear()
            if (room.layers && room.layers.length > 0) {
                room.layers[0].children.length > 0 &&
                    room.layers[0].children.forEach((prespective) => {
                        if (prespective.dimension) {
                            var myPath = new paper.Path()

                            prespective.relatedCurvePoints.forEach(
                                (axis, index) => {
                                    myPath.add(
                                        new paper.Point(
                                            // (1000 / oldWidth) * axis.x,
                                            // (img.height / oldHeight) * axis.y
                                            axis.x,
                                            axis.y
                                        )
                                    )
                                }
                            )
                            myPath.closed = true
                            myPath.fillColor = '#e0e0e0a1'
                            myPath.opacity = 0
                            prespective.id = myPath._id
                        }
                    })
            }

            var baseCanvas = document.getElementById('main-scene')

            if (!baseCanvas) return
            baseCanvas.setAttribute('width', newWidth)
            baseCanvas.setAttribute('height', newHeight)
            var ctx = baseCanvas.getContext('2d')

            ctx.drawImage(img, 0, 0, newWidth, newHeight)

            dispatch({
                type: types.CHOOOSE_ROOM,
                payload: room,
            })
        }
        img.src = room.editedImageUrl ? room.editedImageUrl : room.image
    }
}

export const uploadRoom = (name, file) => {
    const data = {
        title: name,
        file,
    }
    return (dispatch) => {
        dispatch({
            type: types.OPERATION_STARTED,
        })

        apiService.rooms
            .create(data)
            .then((res) => {
                const result = res.data
                if (result) {
                    dispatch({
                        type: types.UPLOAD_ROOM_SUCCESS,
                    })
                    dispatch(getRooms())
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.OPERATION_FAILED,
                    error: errorMessage,
                })
            })
    }
}

export const editRoom = (roomId, file) => {
    const data = {
        id: roomId,
        file,
    }
    return (dispatch, getState) => {
        dispatch({
            type: types.OPERATION_STARTED,
        })

        apiService.rooms
            .updateImage(data)
            .then((response) => {
                if (response.status == 200) {
                    dispatch({
                        type: types.UPLOAD_ROOM_SUCCESS,
                    })
                    dispatch(getRooms()).then(() => window.location.reload())
                } else {
                    dispatch({
                        type: types.OPERATION_FAILED,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.OPERATION_FAILED,
                    error: errorMessage,
                })
            })
    }
}

export const deleteRoom = (roomId) => {
    const data = { id: roomId }
    return (dispatch, getState) => {
        dispatch({
            type: types.OPERATION_STARTED,
        })

        apiService.rooms
            .delete(data)
            .then((response) => {
                if (response.status == 200 || response.status == 204) {
                    dispatch({
                        type: types.DELETE_ROOM_SUCCESS,
                    })
                    dispatch(getRooms())
                } else {
                    dispatch({
                        type: types.OPERATION_FAILED,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.OPERATION_FAILED,
                    error: errorMessage,
                })
            })
    }
}

export const updateRoomTitle = (id, title) => {
    const data = {
        title,
    }
    return (dispatch) => {
        dispatch({
            type: types.OPERATION_STARTED,
        })
        apiService.rooms
            .update(id, data)
            .then((response) => {
                if (response.status == 200 || response.status == 204) {
                    dispatch({
                        type: types.EDIT_ROOM_TITLE_SUCCESS,
                    })
                    dispatch(getRooms())
                } else {
                    dispatch({
                        type: types.OPERATION_FAILED,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.OPERATION_FAILED,
                    error: errorMessage,
                })
            })
    }
}

export const drawForHelpTour = () => {
    return (dispatch, getState) => {
        // TODO: check for errors
        const room = getState().tools.roomInDesignStage
        const id = getState().tools.roomInDesignStage.layers[0].children[0].id
        const material = getState().tools.allMaterials[0]
        const multiply = getState().tools.multiply
        dispatch(dropAndDrawMaterial(room, id, material, multiply))
    }
}

export const dropAndDrawMaterial = (
    room,
    id,
    material,
    multiply,
    zoom = 100,
    offsetH = 0,
    offsetV = 0
) => {
    return (dispatch) => {
        dispatch({
            type: types.DRAWING_STARTED,
        })
        const layerChildren = room.layers[0].children
        const currentLayerChild = layerChildren.find((q) => q.id === id)

        let baseCanvas = document.getElementById('main-scene')
        let ctx = baseCanvas.getContext('2d')
        ctx.clearRect(0, 0, baseCanvas.width, baseCanvas.height)

        let img = new Image()
        img.crossOrigin = 'Anonymous'
        img.src = room.editedImageUrl ? room.editedImageUrl : room.image
        img.onload = async () => {
            oldWidth = img.width
            oldHeight = img.height
            let newHeight = img.height
            let newWidth = img.width

            if (img.width > 1000) {
                newWidth = 1000
                newHeight = (img.height / img.width) * 1000
            }

            img.width = newWidth
            img.height = newHeight

            baseCanvas.setAttribute('width', newWidth)
            baseCanvas.setAttribute('height', newHeight)

            ctx.globalCompositeOperation = 'multiply'
            ctx.drawImage(img, 0, 0, newWidth, newHeight)

            if (!room.selectedPrespectives) {
                room.selectedPrespectives = []
            }

            const oldPerspectiveData = room.selectedPrespectives.filter(
                (q) => q.id == id
            )
            let brightness,
                contrast = null

            if (oldPerspectiveData && oldPerspectiveData.length > 0) {
                brightness = oldPerspectiveData[0].brightness
                contrast = oldPerspectiveData[0].contrast
            }
            room.selectedPrespectives = room.selectedPrespectives
                .filter((q) => q.id != id)
                .concat({
                    id: id,
                    monhani: currentLayerChild.pathData,
                    curvePoints: currentLayerChild.relatedCurvePoints,
                    material: { ...material },
                    image: room.image,
                    zoom: zoom,
                    offsetH: offsetH,
                    offsetV: offsetV,
                    brightness: brightness,
                    contrast: contrast,
                })

            const drawWarpedImage = (scaledImage, perspective, layerChild) =>
                new Promise((resolve, reject) => {
                    let image = new Image()
                    image.crossOrigin = 'Anonymous'
                    image.onload = function () {
                        let myCanvas = document.createElement('canvas')
                        myCanvas.style.position = 'absolute'
                        let context = myCanvas.getContext('2d')
                        myCanvas.setAttribute('width', baseCanvas.width)
                        myCanvas.setAttribute('height', baseCanvas.height)

                        // TODO: removed if confirmed
                        // drawPathData(
                        //     context,
                        //     layerChild.relatedCurvePoints,
                        //     1000 / oldWidth,
                        //     baseCanvas.height / oldHeight
                        // )

                        context.clip(new Path2D(layerChild.pathData))
                        context.drawImage(image, 0, 0)

                        let myNewImage = new Image()
                        myNewImage.crossOrigin = 'Anonymous'
                        myNewImage.onload = function () {
                            perspective.imageData = myCanvas.toDataURL()
                            ctx.drawImage(myNewImage, 0, 0)
                            resolve()
                        }
                        myNewImage.src = myCanvas.toDataURL()
                    }

                    image.src = scaledImage
                })

            if (multiply != 0.8) {
                ctx.clearRect(0, 0, baseCanvas.width, baseCanvas.height)
                grayscalePathOnImage(ctx, img, room, multiply, baseCanvas)
            }
            for (const perspective of room.selectedPrespectives) {
                let layerChild = layerChildren.find(
                    (x) => x.id == perspective.id
                )
                if (!layerChild) continue
                if (layerChild.id === perspective.id) {
                    const backgroundImgWidth = baseCanvas.width
                    const backgroundImgHeight = baseCanvas.height
                    const textureUrl = perspective.material.editedImageUrl
                        ? perspective.material.editedImageUrl
                        : perspective.material.url
                    let destinationPoints = []
                    layerChild.dimension.forEach((item) => {
                        destinationPoints.push({
                            index: item.index,
                            x: (item.x * 1000) / oldWidth,
                            y: (item.y * baseCanvas.height) / oldHeight,
                            isMain: true,
                            faces: item.faces,
                        })
                    })
                    // if (mode === null)
                    //     drawPerspective(
                    //         destinationPoints,
                    //         textureUrl,
                    //         backgroundImgWidth,
                    //         backgroundImgHeight,
                    //         layerChild.plan,
                    //         getFinalScaledImage,
                    //         layerChild.gridSize,
                    //         layerChild.margin,
                    //         layerChild.textureScale,
                    //         layerChild.perspective
                    //     )
                    // else

                    if (perspective.imageData != null) {
                        if (
                            perspective.brightness == null ||
                            perspective.contrast == null
                        ) {
                            var onFlyImage = await addImageProcess(
                                perspective.imageData
                            )
                            ctx.drawImage(onFlyImage, 0, 0)
                        }
                    } else {
                        const warpedImage = await warpOnCube(
                            destinationPoints,
                            layerChild.perspective,
                            textureUrl,
                            backgroundImgWidth,
                            backgroundImgHeight,
                            layerChild.pathData,
                            { zoom, offsetH, offsetV },
                            layerChild.cubeData
                        )
                        await drawWarpedImage(
                            warpedImage,
                            perspective,
                            layerChild
                        )
                    }
                }
            }

            // await DrawPathWithFilters(room)
            // dispatch({
            //     type: types.CHOOOSE_ROOM,
            //     payload: room,
            // })
            dispatch({
                type: types.RESET_DRAG,
                payload: room,
            })

            dispatch({
                type: types.SELECT_CURVE,
                payload: id,
            })
            dispatch({
                type: types.APPLY_TEXTURE_ZOOM,
                payload: {
                    zoom: zoom,
                    offsetH: offsetH,
                    offsetV: offsetV,
                    room: room,
                },
            })
            if (brightness || contrast) {
                let perspective = room.selectedPrespectives.filter(
                    (q) => q.id == id
                )[0]
                dispatch(
                    applyCurveFilter(
                        perspective,
                        brightness,
                        contrast,
                        room,
                        multiply
                    )
                )
            }
            dispatch({
                type: types.DRAWING_ENDED,
            })
        }
    }
}

export const selectCurve = (id, roomInDesignStage) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.SELECT_CURVE,
            payload: id,
        })

        // let perspective = id
        // if (typeof perspective !== 'object' && perspective !== null) {
        //     if (!roomInDesignStage.selectedPrespectives) return
        //     perspective = roomInDesignStage.selectedPrespectives.find(
        //         (q) => q.id === perspective
        //     )
        //     if (!perspective) return
        // }
        // dispatch({
        //     type: types.APPLY_CURVE_FILTER,
        //     payload: {
        //         brightness: perspective.brightness ?? 0,
        //         contrast: perspective.contrast ?? 0,
        //     },
        // })
    }
}

function grayscalePathOnImage(ctx, img, roomInDesignStage, range, canvas) {
    var paths = []
    roomInDesignStage.selectedPrespectives.forEach((q) => {
        const path = new Path2D()
        path.moveTo(q.curvePoints[0].x, q.curvePoints[0].y)
        for (let index = 1; index < q.curvePoints.length; index++) {
            path.lineTo(q.curvePoints[index].x, q.curvePoints[index].y)
        }
        path.closePath()
        paths.push(path)
    })

    ctx.drawImage(img, 0, 0)

    var width = canvas.width * 2
    var height = canvas.height
    var imgPixels = ctx.getImageData(0, 0, width, height)

    for (var y = 0; y < height; y++) {
        for (var x = 0; x < width; x++) {
            var i = y * 4 * width + x * 4
            var avg =
                (imgPixels.data[i] +
                    imgPixels.data[i + 1] +
                    imgPixels.data[i + 2]) /
                3

            if (avg < 50) {
                avg += Math.pow(256 - avg, range + 0.09)
            } else if (avg >= 50 && avg < 100) {
                avg += Math.pow(256 - avg, range + 0.08)
            } else if (avg >= 100 && avg < 150) {
                avg += Math.pow(256 - avg, range + 0.05)
            } else if (avg >= 150 && avg < 200) {
                avg += Math.pow(256 - avg, range + 0.04)
            } else if (avg >= 200 && avg < 225) {
                avg += Math.pow(256 - avg, range + 0.03)
            }

            paths.forEach((element) => {
                if (
                    ctx.isPointInPath(element, x + 1, y) &&
                    ctx.isPointInPath(element, x - 1, y) &&
                    ctx.isPointInPath(element, x, y + 1) &&
                    ctx.isPointInPath(element, x, y - 1)
                ) {
                    imgPixels.data[i] = avg
                    imgPixels.data[i + 1] = avg - 5
                    imgPixels.data[i + 2] = avg - 15
                }
            })
        }
    }

    ctx.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height)
}

const addImageProcess = (src) => {
    return new Promise((resolve, reject) => {
        let img = new Image()
        img.crossOrigin = 'Anonymous'
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = src
    })
}

export const applyCurveFilter = (
    perspective,
    brightness,
    contrast,
    room,
    multiply
) => {
    var a = typeof perspective
    return async (dispatch, getState) => {
        dispatch({
            type: types.DRAWING_STARTED,
        })
        if (typeof perspective != 'object') {
            perspective = room.selectedPrespectives.find(
                (q) => q.id == perspective
            )
        }
        perspective.brightness = brightness
        perspective.contrast = contrast

        room.selectedPrespectives
            .filter((q) => q.id !== perspective.id)
            .concat(perspective)

        let mainImage = await addImageProcess(room.image)

        let mainCanvas = document.getElementById('main-scene')
        let ctx = mainCanvas.getContext('2d')

        ctx.clearRect(0, 0, mainCanvas.width, mainCanvas.height)

        ctx.drawImage(mainImage, 0, 0)
        if (multiply != 0.8) {
            globalMultiply = multiply

            ctx.clearRect(0, 0, mainCanvas.width, mainCanvas.height)

            grayscalePathOnImage(ctx, mainImage, room, multiply, mainCanvas)
        }

        room.selectedPrespectives
            .filter((q) => q.brightness == null || q.contrast == null)
            .forEach(async (q) => {
                //get image object from image base 64
                let img = await addImageProcess(q.imageData)

                ctx.drawImage(img, 0, 0)

                // if (typeof perspective !== 'object' && perspective !== null) {
                //     if (room.selectedPrespectives) return
                //     perspective = room.selectedPrespectives.find(
                //         (q) => q.id === perspective
                //     )
                //     if (!perspective) return
                // }
            })

        await DrawPathWithFilters(room)

        dispatch({
            type: types.APPLY_CURVE_FILTER,
            payload: {
                brightness: brightness,
                contrast: contrast,
                room: room,
                multiply: multiply,
            },
        })
        dispatch({
            type: types.DRAWING_ENDED,
        })
    }
}

export const applyTextureZoom = (
    perspective,
    zoom,
    offsetH,
    offsetV,
    room,
    multiply
) => {
    return async (dispatch, getState) => {
        if (typeof perspective != 'object') {
            perspective = room.selectedPrespectives.find(
                (q) => q.id == perspective
            )
        }

        perspective.zoom = zoom
        perspective.offsetH = offsetH
        perspective.offsetV = offsetV

        room.selectedPrespectives
            .filter((q) => q.id !== perspective.id)
            .concat(perspective)

        dispatch(
            dropAndDrawMaterial(
                room,
                perspective.id,
                perspective.material,
                multiply,
                zoom,
                offsetH,
                offsetV
            )
        )
    }
}

const setContrast = function (imgData, contrast) {
    var d = imgData.data
    contrast = contrast / 100 + 1
    var intercept = 128 * (1 - contrast)
    for (var i = 0; i < d.length; i += 4) {
        d[i] = d[i] * contrast + intercept
        d[i + 1] = d[i + 1] * contrast + intercept
        d[i + 2] = d[i + 2] * contrast + intercept
    }
    return imgData
}

const setBrightness = function (imgData, brightness) {
    var d = imgData.data
    for (var i = 0; i < d.length; i += 4) {
        d[i] += brightness
        d[i + 1] += brightness
        d[i + 2] += brightness
    }
    return imgData
}

const DrawPathWithFilters = async (room) => {
    for (let index = 0; index < room.selectedPrespectives.length; index++) {
        const perspective = room.selectedPrespectives[index]
        if (perspective.contrast == null || !perspective.brightness == null) {
            continue
        }

        let baseCanvas = document.getElementById('main-scene')
        let ctx = baseCanvas.getContext('2d')

        //get image object from image base 64
        let image = await addImageProcess(perspective.imageData)

        let onFlyPathCanvas = document.createElement('canvas')
        let onFlyPathContext = onFlyPathCanvas.getContext('2d')
        onFlyPathCanvas.setAttribute('width', baseCanvas.width)
        onFlyPathCanvas.setAttribute('height', baseCanvas.height)
        onFlyPathContext.drawImage(image, 0, 0)

        onFlyPathContext.putImageData(
            setContrast(
                onFlyPathContext.getImageData(
                    0,
                    0,
                    baseCanvas.width,
                    baseCanvas.height
                ),
                perspective.contrast
            ),
            0,
            0
        )
        onFlyPathContext.putImageData(
            setBrightness(
                onFlyPathContext.getImageData(
                    0,
                    0,
                    baseCanvas.width,
                    baseCanvas.height
                ),
                perspective.brightness
            ),
            0,
            0
        )
        var images = []
        images.push(await addImageProcess(onFlyPathCanvas.toDataURL()))
        images.forEach((img) => {
            ctx.drawImage(img, 0, 0)
        })
    }
}

const drawPathData = (
    context,
    pathData,
    points,
    ratioWidth,
    ratioHeight,
    isPath = false
) => {
    if (isPath) {
        context.beginPath()
        context.fillStyle = '#FFF'
        context.lineWidth = 1
        context.globalAlpha = 1
        context.globalCompositeOperation = 'copy'
        const p = new Path2D(pathData)
        context.stroke(p)
    } else {
        context.beginPath()
        context.moveTo(points[0].x * ratioWidth, points[0].y * ratioHeight)
        for (let index = 1; index < points.length; index++) {
            const element = points[index]
            context.lineTo(element.x * ratioWidth, element.y * ratioHeight)
        }
        context.closePath()
    }
}

export const changeMultiplyIntensity = (roomInDesignStage, value) => {
    return async (dispatch) => {
        dispatch({
            type: types.DRAWING_STARTED,
        })
        var mainImage = await addImageProcess(roomInDesignStage.image)

        var mainCanvas = document.getElementById('main-scene')
        var ctx = mainCanvas.getContext('2d')
        ctx.clearRect(0, 0, mainCanvas.width, mainCanvas.height)
        var temp = 1

        grayscalePathOnImage(
            ctx,
            mainImage,
            roomInDesignStage,
            value,
            mainCanvas
        )

        roomInDesignStage.selectedPrespectives
            .filter((q) => q.brightness == null || q.contrast == null)
            .forEach((q) => {
                addImageProcess(q.imageData)
                    .then((img) => {
                        ctx.drawImage(img, 0, 0)
                    })
                    .catch((error) => console.log(error))
            })

        await DrawPathWithFilters(roomInDesignStage)

        dispatch({
            type: types.CHANGE_MULTIPLY,
            payload: {
                value: value,
            },
        })
        dispatch({
            type: types.DRAWING_ENDED,
        })
    }
}

export const resetMultiply = (roomInDesignStage) => {
    return async (dispatch) => {
        dispatch({
            type: types.DRAWING_STARTED,
        })
        var mainImage = await addImageProcess(roomInDesignStage.image)

        var mainCanvas = document.getElementById('main-scene')
        var ctx = mainCanvas.getContext('2d')
        ctx.clearRect(0, 0, mainCanvas.width, mainCanvas.height)
        ctx.drawImage(mainImage, 0, 0)
        roomInDesignStage.selectedPrespectives
            .filter((q) => q.brightness == null || q.contrast == null)
            .forEach((q) => {
                addImageProcess(q.imageData)
                    .then((img) => {
                        ctx.drawImage(img, 0, 0)
                    })
                    .catch((error) => console.log(error))
            })
        await DrawPathWithFilters(roomInDesignStage)
        dispatch({
            type: types.CHANGE_MULTIPLY,
            payload: {
                value: 0.8,
            },
        })
        dispatch({
            type: types.DRAWING_ENDED,
        })
    }
}
